export default "__VITE_ASSET__C9BYHri4__"